import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from '../../../../model';
import styles from './style.css';
import isDevMode from '../../../../utils/isDevMode';

class List extends React.PureComponent {
    static propTypes = {
        searchValueUpdate: PropTypes.func,
        groupHideStateUpdate: PropTypes.func,
        groupHideState: PropTypes.object,
        chipsHideStateUpdate: PropTypes.func,
        chipsHideState: PropTypes.object,
        searchValue: PropTypes.string,
        chips: PropTypes.array,
        listIsShow: PropTypes.bool,
        openDialogCallback: PropTypes.func,
    };

    searchHandle = e => {
        this.props.searchValueUpdate(e.target.value);
    };
    transfromData(data, value) {
        const newData = data.filter(
            item => item.title.includes(value) && ((!isDevMode() && item.user === 'editor') || isDevMode()),
        );
        const result = {};

        for (const item of newData) {
            if (typeof result[item.groupName] === 'undefined') {
                result[item.groupName] = [];
            }
            result[item.groupName].push(item);
        }

        return result;
    }
    triggerHandle(key) {
        this.props.groupHideStateUpdate({ [key]: !this.props.groupHideState[key] });
    }
    triggerMask(item) {
        this.props.chipsHideStateUpdate({
            [item.uid]: !this.props.chipsHideState[item.uid],
        });
    }
    openDialog(item) {
        window.scrollTo({ top: item.rect.top });
        this.props.openDialogCallback(item);
    }
    renderList(data) {
        const { groupHideState, chipsHideState } = this.props;

        return Object.keys(data).map(key => {
            return (
                <f-div key={key} class={styles.group}>
                    <f-div
                        class={groupHideState[key] ? styles.groupTitle : styles.groupTitleOpen}
                        onClick={() => {
                            this.triggerHandle(key);
                        }}>
                        <f-span class={groupHideState[key] ? styles.arrow : styles.arrowOpen} />
                        {key}
                    </f-div>
                    <f-div class={groupHideState[key] ? styles.groupList : styles.groupListOpen}>
                        {data[key].filter(item => (!isDevMode() && item.user === 'editor') || isDevMode()).map(item => {
                            return (
                                <f-div key={item.uid} class={styles.listItem}>
                                    <f-div
                                        class={styles.listTitle}
                                        onClick={() => {
                                            this.openDialog(item);
                                        }}>
                                        {item.title}({item.type}-{item.id})
                                    </f-div>
                                    <f-div class={styles.listTools}>
                                        <f-span
                                            class={chipsHideState[item.uid] ? styles.iconMaskHide : styles.iconMask}
                                            title={chipsHideState[item.uid] ? '显示蒙层' : '隐藏蒙层'}
                                            onClick={() => {
                                                this.triggerMask(item);
                                            }}
                                        />
                                        <f-span
                                            class={styles.iconEdit}
                                            title="编辑"
                                            onClick={() => {
                                                this.openDialog(item);
                                            }}
                                        />
                                    </f-div>
                                </f-div>
                            );
                        })}
                    </f-div>
                </f-div>
            );
        });
    }
    render() {
        const { searchValue, chips } = this.props;

        return (
            <f-div class={this.props.listIsShow ? styles.listContainerShow : styles.listContainer}>
                <f-div class={styles.searchBox}>
                    <input type="input" value={searchValue} onChange={this.searchHandle} placeholder="输入过滤词" />
                </f-div>
                <f-div class={styles.listWrap}>
                    <f-div class={styles.listBody}>{this.renderList(this.transfromData(chips, searchValue))}</f-div>
                </f-div>
            </f-div>
        );
    }
}

const mapStateToProps = state => ({
    chips: state.chips,
    listIsShow: state.uiState.listIsShow,
    groupHideState: state.groupHideState,
    chipsHideState: state.chipsHideState,
    searchValue: state.searchValue,
});

const mapDispatchToProps = dispatch => ({
    searchValueUpdate: value => dispatch(actions.searchValueUpdate(value)),
    groupHideStateUpdate: data => dispatch(actions.groupHideStateUpdate(data)),
    chipsHideStateUpdate: data => dispatch(actions.chipsHideStateUpdate(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(List);
